import firebase from 'firebase';
import _ from 'lodash';

import View from '../../_components/view/view.js';
import usersTpl from './users.tpl.html';
import './users.styles.less';

import UserView from './user/user.view.js';

class UsersView extends View {

	constructor (data, options) {
		super(usersTpl, data, options);

		this.userViews = [];
		this.usersRef = firebase.database().ref('users/');
		this.playersRef = firebase.database().ref('players/');
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			usersList: '.users-list',
			btnFilterUnlinked: '.btn.unlinked-users',
			btnFilterLinked: '.btn.linked-users',
			btnFilterAll: '.btn.all-users'
		});
	}

	render(data) {
		super.render(data);
		this.initializeUsersData();
	}

	initializeUsersData() {
		this.usersRef.on('value', __users => {
			this.updateUsersList(__users);
		});

		this.playersRef.on('value', __players => {
			let players = __players.val();
			this.linkedPlayersByUserId = {};
			this.unlinkedPlayers = [];

			_.each(players, player => {
				if (player.userId) {
					this.linkedPlayersByUserId[player.userId] = player;
				} else {
					this.unlinkedPlayers.push(player);
				}
			});
		});
	}

	initializeEvents() {
		super.initializeEvents();
		
		this.ui.btnFilterUnlinked.click(() => this.updateUsersList(this.__users, 'unlinked'));
		this.ui.btnFilterLinked.click(() => this.updateUsersList(this.__users, 'linked'));
		this.ui.btnFilterAll.click(() => this.updateUsersList(this.__users, 'all'));
	}

	updateUsersList(__users, filter) {
		filter = filter || this.filter;

		this.removeUsersList();

		_.each(__users.val(), (user, userId) => {

			switch(filter) {
				case 'unlinked':
					if (!this.linkedPlayersByUserId[userId]) {
						this.appendUserToList(user);
					}
					break;
				case 'linked':
					if (this.linkedPlayersByUserId[userId]) {
						this.appendUserToList(user);
					}
					break;
				default: this.appendUserToList(user);
			}
			
		});

		//Activate current filter button
		this.$el.find('.filters > .btn').removeClass('btn-info');
		switch(filter) {
			case 'unlinked': this.ui.btnFilterUnlinked.addClass('btn-info'); break;
			case 'linked': this.ui.btnFilterLinked.addClass('btn-info'); break;
			default: this.ui.btnFilterAll.addClass('btn-info'); break;
		}

		this.filter = filter;
		this.__users = __users;
	}

	appendUserToList(user) {
		let userView = new UserView(user, {user: user});
		this.userViews.push(userView);
		userView.appendTo(this.ui.usersList);
	}

	removeUsersList() {
		_.forEach(this.userViews, userView => {
			userView.remove();
		});

		this.userViews = [];
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
	}

}

export default UsersView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/users/users.view.js